import React from "react";
import { toast } from "react-toastify";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateProspection } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { ProspectionType } from "../../../__generated__/globalTypes";
import { prospectionTypeLabel } from "../../../helpers/enum-labels";

interface IProps {
  customerId?: number;
  onCompleted: () => void;
}

export const ProspectionForm: React.FC<IProps> = ({ customerId, onCompleted }) => {
  const { form, submit, loading } = useCreateProspection({
    defaultValues: { customerId, type: ProspectionType.Phone, automatique: false },
    onCompleted: () => {
      toast.success("La prospection a été enregistrée avec succès");
      form.reset({ customerId, type: ProspectionType.Phone, automatique: false });
      onCompleted();
    },
  });

  const type = form.watch("type");

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {!customerId && (
        <CustomerSelectSearch form={form} name="customerId" label="Client (optionnel)" />
      )}
      <Select
        label="Type"
        className="w-full"
        {...form.register("type", { required: true })}
      >
        {Object.keys(ProspectionType).map((key) => (
          <option key={key} value={key}>
            {prospectionTypeLabel(key)}
          </option>
        ))}
      </Select>
      {type === ProspectionType.Email ? (
        <Input
          label="Email"
          type="email"
          className="w-full"
          {...form.register("email")}
          placeholder="contact@exemple.fr"
        />
      ) : (
        <Input
          label="Téléphone"
          className="w-full"
          {...form.register("phone")}
          placeholder="0601020304"
        />
      )}
      <Textarea
        label="Message"
        className="w-full"
        {...form.register("message", { required: "Message requis" })}
        placeholder="Contenu du message envoyé..."
      />
      <label className="w-full flex items-center gap-2">
        <input type="checkbox" {...form.register("automatique")} />
        <span className="text-sm">Envoi automatique</span>
      </label>
      <Button onClick={submit} loading={loading} disabled={loading}>
        Enregistrer la prospection
      </Button>
    </div>
  );
};
